/* REMENTE LUXE 共通の動き（2026-10-23 サイト全体の形づくり担当）
   1) スクロールで現れる：[data-lx-reveal] に .is-in を付ける（style="--lx-d:.2s" で遅らせる）。.lx-kicker も同時に光る
   2) メニュー：キーボード・タップで開く（.is-open）、Esc で閉じる
   3) カート：<rlx-cart-plus> の中身を /?sections=remente-cart-plus から取り直す（送料無料まで・一緒に使う）
   動きを減らす設定（prefers-reduced-motion）の時は、最初から全部見せる */
(function () {
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) reveal */
  function reveal(scope) {
    var els = (scope || d).querySelectorAll('[data-lx-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  window.rlxReveal = reveal;
  /* 予備：IntersectionObserver が遅れる端末でも、スクロール位置で確実に表示する */
  var ticking = false;
  function sweep() {
    ticking = false;
    var h = window.innerHeight || 800;
    d.querySelectorAll('[data-lx-reveal]:not(.is-in)').forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < h * 0.96 && r.bottom > -50) e.classList.add('is-in');
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; setTimeout(sweep, 80); } }, { passive: true });
  window.addEventListener('load', sweep);

  /* 2) desktop nav: click/keyboard toggle */
  function navInit() {
    d.querySelectorAll('.rlx-nav__item.has-panel').forEach(function (li) {
      var a = li.querySelector('.rlx-nav__link');
      if (!a || a.dataset.rlx) return;
      a.dataset.rlx = '1';
      a.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowDown') { ev.preventDefault(); li.classList.add('is-open'); a.setAttribute('aria-expanded', 'true'); var f = li.querySelector('.rlx-panel a'); if (f) f.focus(); }
      });
      li.addEventListener('mouseleave', function () { li.classList.remove('is-open'); a.setAttribute('aria-expanded', 'false'); });
      li.addEventListener('mouseenter', function () { a.setAttribute('aria-expanded', 'true'); });
    });
    d.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape') return;
      d.querySelectorAll('.rlx-nav__item.is-open').forEach(function (li) { li.classList.remove('is-open'); });
      var ae = d.activeElement;
      if (ae && ae.closest && ae.closest('.rlx-panel')) { var l = ae.closest('.rlx-nav__item').querySelector('.rlx-nav__link'); if (l) l.focus(); }
    });
  }

  /* 3) cart plus */
  var busy = false, queued = false;
  function cartPlusRefresh() {
    var hosts = d.querySelectorAll('rlx-cart-plus');
    if (!hosts.length) return;
    if (busy) { queued = true; return; }
    busy = true;
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + '?sections=remente-cart-plus';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var html = j && j['remente-cart-plus'];
      if (!html) return;
      var tmp = d.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-rlc-inner]');
      hosts.forEach(function (h) { h.innerHTML = inner ? inner.innerHTML : ''; });
    }).catch(function () {}).then(function () {
      busy = false;
      if (queued) { queued = false; cartPlusRefresh(); }
    });
  }
  window.rlxCartPlusRefresh = cartPlusRefresh;

  d.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('.rlc__add');
    if (!b) return;
    ev.preventDefault();
    var id = parseInt(b.getAttribute('data-id'), 10);
    if (!id) return;
    b.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-ajax' })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (res) {
      d.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: res, preventCartOpen: true } }));
      cartPlusRefresh();
    }).catch(function () {
      b.disabled = false;
      b.textContent = b.getAttribute('data-err') || '!';
    });
  });
  ['ajaxProduct:added', 'cart:updated', 'cart:open', 'headerDrawer:opened'].forEach(function (n) {
    d.addEventListener(n, function (e) {
      if (n === 'headerDrawer:opened' && !(e.target && e.target.getAttribute && e.target.getAttribute('open') === 'cart:open')) return;
      setTimeout(cartPlusRefresh, 120);
    });
  });

  function init() {
    /* いま画面に見えている要素は最初から表示済みにしてから .lx-ready を付ける（ファーストビューを隠さない） */
    var vh = window.innerHeight || 800;
    d.querySelectorAll('[data-lx-reveal]').forEach(function (e) { if (e.getBoundingClientRect().top < vh) e.classList.add('is-in'); });
    root.classList.add('lx-ready');
    reveal();
    navInit();
    /* カートページでは最初に1回。ドロワーは開いた時（cart:open）だけ取りに行く（全ページで余計な通信をしない） */
    if (d.body && d.body.classList.contains('template-cart')) {
      cartPlusRefresh();
      window.addEventListener('load', function () { setTimeout(function () { var h = d.querySelector('rlx-cart-plus'); if (h && !h.innerHTML.trim()) cartPlusRefresh(); }, 600); });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function (e) { reveal(e.target); navInit(); });
})();
